<template>
    <div class="shopMobActivity">
        <div class="titleBox" v-show="setting.isdisplaytitle === 1 || setting.isdisplayall">
            <div class="title"><span v-show="setting.isdisplaytitle === 1">{{setting.titlename}}</span></div>
            <div class="checkMore" v-show="setting.isdisplayall">查看更多</div>
        </div>
        <!-- 大图 -->
        <div class="bigimage" v-if="setting.liststyle === 'bigimage'">
            <div class="activityItem" v-for="(item, index) in setting.datalist" :key="index">
                <div class="imgBox">
                    <img :src="item.furl" alt="">
                    <div class="status">
                        <div class="activityIng" v-if="item.status === 1">活动中</div>
                        <div class="applyIng" v-if="item.status === 2">报名中</div>
                        <div class="finishEd" v-if="item.status === 3">已结束</div>
                    </div>
                    <div class="viewCount">
                        <img src="../../../../../common/images/shop/view.png" alt="">
                        <span>{{item.viewcount}}</span>
                    </div>
                </div>
                <div class="msgBox">
                    <p class="msgTitle">{{item.objectname}}</p>
                    <p class="msgDesc">
                        <span class="descText">
                            {{item.desc}}
                        </span>
                    </p>
                    <div class="whetherFree">
                        <p class="free" v-if="!item.saleprice">免费</p>
                        <div class="price" v-else>￥<span class="saleprice">{{item.saleprice}}</span><del v-if="item.uprice" class="uprice">￥{{item.uprice}}</del> </div>
                    </div>
                </div>
                <div class="placeAndTime">
                    <div class="place">
                        <img src="../../../../../common/images/shop/place.png" alt="">
                        <span>{{item.address}}</span>
                    </div>
                    <div class="time">
                        <img src="../../../../../common/images/shop/time.png" alt="">
						<span>{{item.begintime.substr(0, 10)}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 详情列表 -->
        <div class="detail" v-if="setting.liststyle === 'detail'">
            <div class="activityItem" v-for="(item, index) in setting.datalist" :key="index">
                <div class="imgBox">
                    <img :src="item.furl" alt="">
                    <div class="status">
                        <div class="activityIng" v-if="item.status === 1">活动中</div>
                        <div class="applyIng" v-if="item.status === 2">报名中</div>
                        <div class="finishEd" v-if="item.status === 3">已结束</div>
                    </div>
                     <div class="viewCount">
                        <img src="../../../../../common/images/shop/view.png" alt="">
                        <span>{{item.viewcount}}</span>
                    </div>
                </div>
                <div class="msgBox">
                    <div class="msgTitle">
                        <span class="text">
                            {{item.objectname}}
                        </span>
                    </div>
                    <div class="time">
                        <img src="../../../../../common/images/shop/time.png" alt="">
 						<span>{{item.begintime.substr(0, 10)}}</span>
                    </div>
                    <div class="place">
                        <img src="../../../../../common/images/shop/place.png" alt="">
                        <div>{{item.address}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getActivityList} from 'api/shop'
import $ from 'jquery'
export default {
    name: 'shopMobActivity',
    data() {
        return {
            liststyle: 'bigimage'
        }
    },
    props: ['setting'],
    mounted() {
        this._getActivityList()
    },
    updated() {
    },
    methods: {
        _getActivityList() {
            this.setLoading(true)
            getActivityList({
                data: {
                    ispublic: '',
                    subject: '',
                    page: 1,
                    pageSize: 2
                },
                success: data => {
                    let tmp = []
                    data.data.forEach(obj => {
                        tmp.push({
                            objectid: obj.kmcinnerid,
                            objectname: obj.kmcname,
                            kmctype: 3,
                            viewcount: obj.viewcount,
                            uprice: 0,
                            saleprice: 0,
                            furl: obj.logoPic.furl,
                            desc: '',
                            address: obj.address,
                            begintime: obj.begintime,
                            status: obj.status
                        })
                    })
                    let tmpList = $.extend(true, [], this.shopMob)
                    tmpList.forEach((obj,index) => {
                        if (obj.comtype === 'activity') {
                            obj.datalist = tmp
                        }
                    })
                    this.setShopMob(tmpList)
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setShopMob',
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.shopMobActivity {
    width: 100%;
    padding: 0.64rem;
    box-sizing: border-box;
    min-height: 257px;
    background: #fff;
    .titleBox{
        display: flex;
        justify-content: space-between;
        height: 0.84rem;
        .title{
            font-size: 0.68rem;
            width: 11rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            span{
                font-weight: 600;
            }
        }
        .checkMore{
            font-size: 0.46rem;
            color: #909399;
        }
    }
    // 大图
    .bigimage{
        .activityItem{
            box-shadow:0 0.08rem 0.12rem 0 rgba(0,0,0,0.21);
            border-radius:4px;
            margin-top: 0.96rem;
            .imgBox{
                position: relative;
                img{
                    width: 100%;
                    // width: 13.6rem;
                    height: 7.72rem;
                }
                .status{
                    position: absolute;
                    top: 0;
                    div{
                        width: 1.92rem;
                        height: 0.76rem;
                        color: #fff;
                        text-align: center;
                        line-height: 0.76rem;
                        font-size: 0.48rem;
                    }
                    .activityIng{
                        background: #409EFF;
                    }
                    .applyIng{
                        background: #E6A23C;
                    }
                    .finishEd{
                        background: #909399;
                    }
                }
                .viewCount{
                    position: absolute;
                    bottom: 0.32rem;
                    color: #fff;
                    left: 0.32rem;
                    display: flex;
                    align-items: center;
                    img{
                        width: 0.48rem;
                        height: 0.48rem;
                        margin-right: 0.05rem;
                    }
                }
            }
            .msgBox{
                padding: 0.32rem;
                .msgTitle{
                    font-size: 0.56rem;
                    line-height: 0.68rem;
                    width: 13.08rem;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    font-weight: 500;
                }
                .msgDesc{
                    width: 13.08rem;
                    height: 1.44rem;
                    font-size: 0.48rem;
                    color: #909399;
                    line-height: 0.72rem;
                    overflow: hidden;
                    .descText {
                        float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        margin-left: -10px;
                        width: 13.08rem;
                        word-break: break-all;
                        font-size: 0.48rem;
                        font-weight: 400;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 10px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 1.44rem;
                        line-height: 0.72rem;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 37px;
                        margin-left: -37px;
                        /* 移动省略号位置 */
                        position: relative;
                        left: 100%;
                        bottom: 0.7rem;
                        font-weight: 600;
                        // text-align: center;
                        /* "padding"左右总和的值要小于等于".wrap::before"的宽度，但不能为0 */
                        padding-right: 1px;
                        background: #fff;
                    }
                }
                .whetherFree{
                    .free{
                        color: #409EFF;
                        font-size: 0.56rem;
                    }
                    .price{
                        color: #F56C6C;
                        font-size: 0.4rem;
                        .saleprice{
                            font-size: 0.6rem;
                        }
                        .uprice{
                            font-size: 0.48rem;
                            color: #C0C4CC;
                            margin-left: 10px;
                        }
                    }
                }
            }
            .placeAndTime{
                height: 1.24rem;
                background: #F5F7FA;
                display: flex;
                justify-content: space-between;
                padding: 0 0.32rem;
                .place,.time{
                    line-height: 1.24rem;
                    display: flex;
                    align-items: center;
                    img{
                        width: 0.48rem;
                        height: 0.48rem;
                    }
                    span{
                        margin-left: 0.05rem;
                        font-size: 0.48rem;
                        line-height: 0.64rem;
                        color: #909399;
                        width: 4.18rem;
                        display: block;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                }
            }
        }
    }
    // 详细列表
    .detail{
        .activityItem{
            display: flex;
            margin-top: 1rem;
            .imgBox{
                position: relative;
                img{
                    width: 6rem;
                    height: 3rem;;
                }
                .status{
                    position: absolute;
                    top: 0;
                    div{
                        width: 1.92rem;
                        height: 0.76rem;
                        color: #fff;
                        text-align: center;
                        line-height: 0.76rem;
                        font-size: 0.48rem;
                    }
                    .activityIng{
                        background: #409EFF;
                    }
                    .applyIng{
                        background: #E6A23C;
                    }
                    .finishEd{
                        background: #909399;
                    }
                }
                .viewCount{
                    position: absolute;
                    bottom: 8px;
                    left: 8px;
                    display: flex;
                    align-items: center;
                    color: #fff;
                    font-size: 0.44rem;
                    img{
                        width: 0.48rem;
                        height: 0.48rem;
                        margin-right: 0.08rem;
                    }
                }
            }
            .msgBox{
                margin-left: 0.14rem;
                flex: 1;
                .msgTitle{
                    font-size: 0.56rem;
                    width: 7.5rem;
                    height: 1.68rem;
                    line-height: 0.84rem;
                    overflow: hidden;
                    .text {
                        float: right;
                        /* "margin-left"要等于".wrap::before"的宽度 */
                        margin-left: -10px;
                        width: 7.5rem;
                        word-break: break-all;
                        font-weight: 500;
                    }
                    &::before {
                        float: left;
                        content: '';
                        width: 10px;
                        height: 100%;
                    }
                    &::after {
                        float: right;
                        content: "...";
                        /* 行高与".wrap"设置的一致即可 */
                        height: 1.68rem;
                        line-height: 0.84rem;
                        /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                        width: 30px;
                        margin-left: -30px;
                        /* 移动省略号位置 */
                        position: relative;
                        left: 100%;
                        bottom: 0.8rem;;
                        /* "padding"左右总和的值要小于等于".wrap::before"的宽度，但不能为0 */
                        padding-right: 1px;
                        // padding-left: 9px;
                        /*省略号左方的渐变色*/
                        background: #fff;
                        // background: linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                        // background: -moz-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                        // background: -o-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                        // background: -ms-linear-gradient(to right, rgba(255, 255, 255, 0), white 20%, white);
                        // background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), to(white), color-stop(20%, white));
                    }
                }
                .place,.time{
                    display: flex;
                    align-items: center;
                    margin: 0.1rem 0 0;
                    font-size: 0.48rem;
                    color: #909399;
                    img{
                        width: 0.48rem;
                        height: 0.48rem;
                        margin-right: 0.16rem;
                    }
                    div{
                        width: 7rem;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                }
            }
        }
    }
}
</style>
